// NOTE: for user customization
// https://app.shortcut.com/systeme/story/19932/add-class-names-to-the-school-for-customization
export const addPublicCustomClassNamePrefix = (classNames: string | string[]) =>
  (Array.isArray(classNames) ? classNames : [classNames])
    .reduce(
      (res, className) => res + ` ${process.env.NEXT_PUBLIC_CUSTOM_CLASSNAME_PREFIX}-${className}`,
      '',
    )
    .trim()
